export const primary = {
  50: 'rgb(240, 251, 255)',
  100: 'rgb(228, 246, 255)',
  150: 'rgb(215, 242, 254)',
  200: 'rgb(203, 237, 253)',
  250: 'rgb(188, 234, 254)',
  300: 'rgb(173, 231, 255)',
  350: 'rgb(157, 227, 255)',
  400: 'rgb(140, 224, 255)',
  450: 'rgb(90, 201, 255)',
  500: 'rgb(38, 174, 255)',
  550: 'rgb(0, 143, 255)',
  600: 'rgb(20, 108, 253)',
  650: 'rgb(12, 90, 212)',
  700: 'rgb(5, 72, 173)',
  750: 'rgb(2, 54, 136)',
  800: 'rgb(0, 38, 100)',
  850: 'rgb(0, 26, 77)',
  900: 'rgb(0, 16, 55)',
  950: 'rgb(0, 6, 34)',
}
export const accent = {
  50: 'rgb(255, 248, 249)',
  100: 'rgb(255, 242, 244)',
  150: 'rgb(255, 236, 239)',
  200: 'rgb(255, 230, 234)',
  250: 'rgb(255, 219, 224)',
  300: 'rgb(255, 207, 214)',
  350: 'rgb(255, 196, 204)',
  400: 'rgb(255, 184, 193)',
  450: 'rgb(248, 151, 162)',
  500: 'rgb(239, 117, 129)',
  550: 'rgb(228, 79, 95)',
  600: 'rgb(215, 21, 58)',
  650: 'rgb(185, 14, 50)',
  700: 'rgb(155, 7, 42)',
  750: 'rgb(126, 3, 34)',
  800: 'rgb(99, 0, 25)',
  850: 'rgb(76, 0, 16)',
  900: 'rgb(54, 0, 8)',
  950: 'rgb(33, 0, 3)',
}
export const grey = {
  50: 'rgb(250, 250, 250)',
  100: 'rgb(245, 245, 245)',
  150: 'rgb(240, 240, 240)',
  200: 'rgb(235, 235, 235)',
  250: 'rgb(227, 229, 230)',
  300: 'rgb(220, 223, 224)',
  350: 'rgb(212, 217, 219)',
  400: 'rgb(205, 211, 214)',
  450: 'rgb(170, 176, 180)',
  500: 'rgb(136, 143, 146)',
  550: 'rgb(104, 111, 114)',
  600: 'rgb(73, 80, 84)',
  650: 'rgb(63, 69, 73)',
  700: 'rgb(53, 59, 63)',
  750: 'rgb(43, 49, 53)',
  800: 'rgb(34, 39, 43)',
  850: 'rgb(24, 28, 31)',
  900: 'rgb(14, 17, 19)',
  950: 'rgb(5, 7, 9)',
}
